import React, { useEffect, useState } from 'react';
import axios from "axios";

import NotesView from './NotesView';

const Notes = ({ quote }) => {
  const [notes, setNotes] = useState(quote?.notes || '');

  useEffect(() => {
    setNotes(quote?.notes || '');
  }, [quote]);

  const onChange = async (newNotes) => {
    let response;
    try {
      response = await axios.put(`/api/quotes/${quote?.id}/notes`, { notes: newNotes });
    } catch {
      // The interceptor has already told the user; keep what they typed.
      return;
    }

    // A 5xx RESOLVES undefined (global interceptor, which already showed the
    // error). Keep what is on screen — blanking it made the notes look deleted.
    if (!response) return;

    setNotes(response?.data?.notes || '');
  }

  return (
    <NotesView notes={notes} onChange={onChange} />
  );
}

export default Notes;
